<template>
  <div class="relative" ref="switcher">
    <button @click="open = !open" class="flex items-center gap-2 px-3 py-2 rounded-lg text-[#4a5568] hover:bg-[#f7fafc] hover:text-[#0056b3] transition-all">
      <Globe class="w-5 h-5" />
      <span class="text-sm font-medium">{{ currentLabel }}</span>
      <ChevronDown class="w-4 h-4 transition-transform" :class="{ 'rotate-180': open }" />
    </button>
    <div v-show="open" class="absolute right-0 mt-2 w-40 bg-white rounded-xl shadow-lg border border-[#e2e8f0] z-50">
      <button v-for="lang in langs" :key="lang.code" @click="switchLang(lang.code)"
        class="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-[#4a5568] hover:bg-[#e6f0fa] hover:text-[#0056b3] transition-colors">
        <span class="w-5 h-5 rounded-full flex items-center justify-center text-white text-xs font-bold" :class="lang.bg">{{ lang.flag }}</span>
        <span>{{ lang.label }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { Globe, ChevronDown } from 'lucide-vue-next'

const { locale } = useI18n()
const open = ref(false)
const switcher = ref(null)

const langs = [
  { code: 'zh-CN', label: '中文', flag: '中', bg: 'bg-red-500' },
  { code: 'en', label: 'English', flag: 'EN', bg: 'bg-blue-600' },
  { code: 'ar', label: 'العربية', flag: 'ع', bg: 'bg-green-600' }
]

const currentLabel = computed(() => langs.find(l => l.code === locale.value)?.label || '中文')

function switchLang(code) {
  locale.value = code
  open.value = false
}

function onClickOutside(e) {
  if (switcher.value && !switcher.value.contains(e.target)) open.value = false
}

onMounted(() => document.addEventListener('click', onClickOutside))
onUnmounted(() => document.removeEventListener('click', onClickOutside))
</script>
